export default {
  primary: '#111111',
  // yellow: '#f3e14c',
  secondary: '#00A388',
  white: '#EEEEEE'
}
